import algoliasearch from "algoliasearch/lite";
import tableSearch from "./../../shared/tableSearch/tableSearch.vue";
import BrandApi from "../../../../services/api/brandApi";
import Utils from "../../../../services/utils";

const BrandApiService = new BrandApi();

export default {
  components: {
    tableSearch,
  },

  data() {
    return {
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      query: "",
      isTypingSearchQuery: false,
      results: [],
      pagination: {
        page: 1,
        limit: 12,
        totalCount: 0,
      },
    };
  },

  beforeMount() {
    this.searchIndexRetailers = this.algoliaClient.initIndex(this.$env.getOrigin() + "_retailers_sorted_timestamp");

    this.getResults();
  },

  methods: {
    search,
    getResults,
    showLink,
    outboundLink,
  },
};

function search(val) {
  this.pagination.page = 1;
  this.query = val;
  this.getResults();
}

function getResults(page) {
  let _self = this;

  if (page) _self.pagination.page = page;

  _self.results = [];
  _self.$loader.$emit("trigger", true);

  _self.searchIndexRetailers.clearCache();
  _self.searchIndexRetailers
    .search({
      query: _self.query,
      page: _self.pagination.page - 1,
      hitsPerPage: _self.pagination.limit,
      facets: "*,status",
      facetFilters: [["status:PENDING"]],
    })
    .then((response, err) => {
      if (err) {
        _self.$swal("Attention", _self.$utils.formatErrorMessage());

        return;
      }

      _self.results = response.hits;
      _self.pagination.totalCount = response.nbHits;
      _self.$forceUpdate();
      _self.$loader.$emit("trigger", false);
    });
}

function showLink(url) {
  return Utils.isValidUrl(url);
}
function outboundLink(url) {
  if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
    url = "http://" + url;
  }
  return url;
}
